import BaseVue from '@/base/BaseVue';
import {Options} from 'vue-class-component';
import MiTitle from '@/components/title/Title.vue';
import HttpBase from '@/http/base/HttpBase';

@Options({
  components: {
    'mi-title': MiTitle
  }
})
export default class EditJingDian extends BaseVue {
  place: any = [];
  // uploadUrl = `${HttpBase.getRootUrl()}/file/imgUpdate`;
  uploadUrl = HttpBase.QiNiu_URL;
  uploadData: any = {};
  ruleForm = {
    img: '',
    mode: '',
    name: '',
    notes: '',
    type: 0,
    lat: 0,
    lng: 0,
    jinglingId: null,
    distance: null,
    jingdianFiles: [
      {
        languageType: 0,
        type: 0,
        url: null
      },
      {
        languageType: 1,
        type: 0,
        url: null
      },
      {
        languageType: 2,
        type: 0,
        url: null
      }
    ]
  };
  rules = {
    ruleForm: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],
    mode: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],
    img: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],
    name: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],
    notes: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],

    jingdianFiles: [
      {required: true, message: '请填写', trigger: 'blur'},
    ],
  };
  jinglingList: any[] = [];

  async beforeImageUpload(rawFile: any) {
    if (rawFile.size / 1024 / 1024 > 50) {
      this.toast_warn('单张图片大小不能超过50MB!');
      return false;
    }
    let name: string = rawFile.name;
    name = name.substring(name.lastIndexOf('.'));
    const data = await this.http.getImageQiNiuUploadToken({suffix: name});
    this.uploadData = data.data;
    return true;
  }

  // 上传成功，获取返回的图片地址
  handleUpImage(res: any) {
    this.ruleForm.img = `${HttpBase.getRootUrl()}/file/getImage/${res.data}`;
  }

  // 上传成功，获取返回的图片地址
  handleUpImage2(res: any) {
    this.ruleForm.mode = `${HttpBase.getRootUrl()}/file/getImage/${res.data}`;
  }


  handleUpImage3(res: any) {
    // this.ruleForm.audio = `${HttpBase.getRootUrl()}/file/getAudioFile/${res.data}`;
    // this.ruleForm.audio =  this.uploadData.prefix + res.key;
    this.ruleForm.jingdianFiles[0].url = this.uploadData.prefix + res.key;
  }

  handleUpImage4(res: any) {
    // this.ruleForm.audio = `${HttpBase.getRootUrl()}/file/getAudioFile/${res.data}`;
    // this.ruleForm.audio =  this.uploadData.prefix + res.key;
    this.ruleForm.jingdianFiles[1].url = this.uploadData.prefix + res.key;
  }


  handleUpImage5(res: any) {
    // this.ruleForm.audio = `${HttpBase.getRootUrl()}/file/getAudioFile/${res.data}`;
    // this.ruleForm.audio =  this.uploadData.prefix + res.key;
    this.ruleForm.jingdianFiles[2].url = this.uploadData.prefix + res.key;
  }

  // 上传成功，获取返回的图片地址
  handleUpImage1(res: any) {
    console.log(111, res);
    // @ts-ignore
    this.ruleForm.imgs.push({url: `${HttpBase.getRootUrl()}/file/getImage/${res.data}`});
  }

  handleRemove(uploadFile: any, uploadFiles: any) {
    let url = '';
    Object.keys(uploadFile).forEach(item => {
      url += uploadFile[item];
    });
    // @ts-ignore

    this.ruleForm.imgs.splice(this.ruleForm.imgs.indexOf(this.ruleForm.imgs.find((res: any) => {
      return res.url == url;
    })), 1);
  }

  submitForm(item: any) {
    if (this.ruleForm.type == 0) {
      if (this.ruleForm.lat == null || this.ruleForm.lng == null || this.ruleForm.distance == null) {
        this.toast_error('请填写完整信息');
        return;
      }
    }
    if (this.ruleForm.jingdianFiles.filter(item => {
      return item.url == null || item.url == '';
    }).length > 0) {
      this.toast_error('请上传所有景点介绍的文件信息');
      return;
    }
    this.http.editJingDian(this.ruleForm).then(res => {
      this.toast_success(res.msg);
      this.resetForm('refForm');
    }).catch(res => {
      this.toast_error(res.msg);
    });
  }

  mounted() {
    this.http.getJingLingList({ps: 10000}).then(res => {
      this.jinglingList = res.data.list;
    });

    this.http.getJingDianDetail({id: this.getParameters().id}).then(res => {
      if (res.data.jingdianFiles.length == 0) {
        res.data.jingdianFiles = [
          {
            languageType: 0,
            type: 0,
            url: null
          },
          {
            languageType: 1,
            type: 0,
            url: null
          },
          {
            languageType: 2,
            type: 0,
            url: null
          }
        ];
      }
      this.ruleForm = res.data;
      // this.ruleForm.imgs = imgs;
    }).catch(res => {
      this.toast_error(res.msg);
    });
  }

}
